/* eslint-disable @typescript-eslint/ban-types */
import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { log } from '@s4l/monitoring'

export type FacilitiesID = (typeof ALLOWED_FACILITY_ID)[number]

const ALLOWED_FACILITY_ID = [
  'wi-fi',
  'luggage-room',
  'wired-internet',
  'garage',
  'check-out-hour',
  'room-service',
  'check-in-hour',
  '24-hour-reception',
  'air-conditioning',
  'lift-access',
  'laundry-service',
  'car-park',
  'hotel-safe',
  'wheelchair-accessible',
  'large-pets-allowed-over-5-kg',
  'secure-parking',
  'clothes-dryer',
  'multilingual-staff',
  'terrace',
  'garden',
  'newspapers',
  'outdoor-freshwater-pool',
  'air-conditioning-in-public-areas',
  'private-pool',
  'car-hire',
  'gym',
  'massage',
  'airport-shuttle',
  'shop',
  'fitness',
  'sauna',
  'currency-exchange-facilities',
  '24-hour-security',
  'beach-access',
  'tv-lounge',
  'spa-centre',
  'bellboy-service',
  'towels-and-bed-linen',
  'parasols',
  'smoke-detector',
  'partners-bike-shop-workshop',
  'sun-loungers',
  'mobile-phone-coverage',
  'ironing-service',
  'golf',
  'small-pets-allowed-under-5-kg',
  'launderette',
  'indoor-freshwater-pool',
  'hot-tub',
  'babysitting-service',
  'bicycle-hire-service',
  'tennis',
  'billiards',
  'late-check-out',
  'fireplace',
  'table-tennis',
  'medical-service',
  'grill-bbq',
  'transfer-service',
  'spa-treatments',
  'game-room',
  'shared-kitchen',
  'sun-terrace',
  'valet-parking',
  'cloakroom',
  'hairdressing-salon',
  'library',
  'steam-bath',
  'childrens-swimming-area',
  'children-playground',
  'dining-area',
  'fishing-activities',
  'bikes-available',
  'electric-kettle',
  'local-and-international-calls',
  'bbq-facilities',
  'newspaper-stand',
  'diving',
  'golf-practice-facility',
  'bicycle-storage',
  'kids-club',
  'horse-riding',
  'towels-beach-pool',
  'taxi-service',
  'cycling-mountain-biking',
  'key-collection',
  'supermarket',
  'indoor-heated-pool',
  'turkish-bath-hamam',
  'nightclub',
  'casino',
  'entertainment-programme-for-adults',
  'canoeing',
  'beauty-salon',
  'bowling-alley',
  'entertainment-programme-for-children',
  'private-beach-area',
  'windsurfing',
  'solarium',
  'jet-ski',
  'aerobics',
  'sailing',
  'beach-volleyball',
  'pub',
  'basketball',
  'karaoke',
  'mini-golf',
  'toaster',
  'skiing',
  'waterskiing',
  'banana-boating',
  'volleyball',
  'ski-storage',
  'darts',
  'squash',
  'surfing',
  'oven',
  'catamaran-sailing',
  'motor-board-ride',
  'pedal-boating',
  'theatre-auditorium',
  'bocce',
  'ski-pass',
  'day-care-centre',
  'archery',
  'waterslides',
  'badminton',
  'outdoor-heated-pool',
  'paddle-tennis',
  'safari',
  'golf-desk',
  'snowboarding',
  'outdoor-saltwater-pool',
  'putting-green',
  'handball',
  'hotels-own-bike-shop-workshop',
  'ski-to-door-acces',
  'tobogganing',
  'indoor-saltwater-pool',
] as const

export const FacilityIDValidation = z.object({
  value: z.string({ required_error: '[FacilityID] value is required' }),
})

export class FacilityID extends Model {
  static create({ value }: { value: FacilitiesID | (string & {}) }) {
    const { error } = FacilityIDValidation.safeParse({ value })
    if (error) {
      log.warn({
        message: '[FacilityID]: Unknown facility ID',
        metadata: { facilityID: value },
      })
    }
    return new FacilityID(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
